import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DocumentTypeService } from '../../../services/document-type.service';
import { DocumentService } from '../../../documents/services/document.service';
import { ActivatedRoute } from '@angular/router';
import { DocumentEntityType } from '../../../message-models/document-entity-type.enum';
import { IDocumentType } from '../../../message-models/document-type.interface';
import { BreadcrumbService } from 'xng-breadcrumb';
import { EntityDocumentSummary } from '../../../message-models/entity-document-summary.class';
import { IEntityDocumentSummary } from '../../../message-models/entity-document-summary';
import { IObservation } from '../../../message-models/observation.interface';
import { ObservationType } from '../../../domain-model/observation.class';
import { ObservationModalService } from '../../../observations/services/observation-modal.service';
import { ObservationsService } from '../../../observations/services/observations.service';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { IObservationSummary } from '../../../message-models/observation-summary.interface';
import { DetailContainerComponent } from '../../../common/components/detail-container/detail-container.component';
import { OurUserService } from '../../../users/services/user.service';
import { IUserInfo } from '../../../users/models/userInfo.interface';
import { consts } from '../../../common/modals/consts';
import { Subscription } from 'rxjs';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { AlertsService } from '../../../alerts/services/alerts.service';
import { IObservationDocumentSummary } from '../../../message-models/observation-document-summary.interface';
import { ObservationDocumentService } from '../../services/observation-document.service';
import { ObservationDocumentSummary } from '../../../message-models/observation-document-summary.class';

@Component({
  selector: 'app-observation-document-details-page',
  templateUrl: './observation-document-details-page.component.html',
  styleUrls: ['./observation-document-details-page.component.scss']
})

export class ObservationDocumentDetailsPageComponent implements OnInit, OnDestroy {

  @ViewChild('docDetailsContainerComponent') docDetailsContainerComponent: DetailContainerComponent;

  loading: boolean;

  isEditing = false;
  documentUploadRequest: FormData;
  tempDocumentSummary: IEntityDocumentSummary;
  formIsValid = false;

  observationDocumentSummary: IObservationDocumentSummary;
  observationDocumentTypes: IDocumentType[];
  observationDocumentObservations: Array<IObservationSummary> = new Array<IObservationSummary>();
  observationSummary: IObservationSummary;
  observationType: string;
  documentId: string;

  public loggedInUser: IUserInfo;
  companyId: string = consts.emptyGuid;
  loggedInUserSubscription: Subscription;
  submitted: boolean = false;

  constructor(private documentTypeService: DocumentTypeService,
    private observationDocumentService: ObservationDocumentService,
    private documentService: DocumentService,
    private breadcrumbService: BreadcrumbService,
    private observationModalService: ObservationModalService,
    private observationsService: ObservationsService,
    private alertsService: AlertsService,
    private activatedRoute: ActivatedRoute,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private userService: OurUserService,
    private errorHandlingService: ErrorHandlingService
  ) {
    this.documentId = this.activatedRoute.snapshot.params.documentId;
    this.breadcrumbService.set('@observationDocument', { label: 'Training Course Document' });
  }

  ngOnInit(): void {
    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUserSubscription = this.userService.getLoggedInUserSubject().subscribe(user => {
        this.setUserAndReload(user);
      })
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  private setUserAndReload(user: IUserInfo) {
    this.loggedInUser = user;
    this.companyId = this.loggedInUser?.companyId;
    if (!this.companyId)
      return;

    if (this.companyId !== consts.emptyGuid) {
      this.documentTypeService.getAllDocumentTypesForEntityType(DocumentEntityType.observation).subscribe(observationDocumentTypes => {
        this.observationDocumentTypes = observationDocumentTypes;
      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      });
      this.observationDocumentService.getObservationDocumentSummary(this.companyId, this.documentId).subscribe(observationDocumentSummary => {
        this.observationDocumentSummary = new ObservationDocumentSummary(observationDocumentSummary);
        this.observationsService.getObservationSummaryById(this.observationDocumentSummary.observationId).subscribe(result => {
          this.observationSummary = result;
          this.observationType = this.observationSummary.operativeId == null ? ' Enterprise' : ' Operative';
          this.populateBreadcrumbs();
        }, () => {
          this.errorHandlingService.showErrorWarning().subscribe(() => {
          });
        });
        this.initObservationDocument();

      }, () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      });
      if (this.companyId) {
        this.observationsService.getDocumentObservations(this.documentId, this.companyId).subscribe(observationDocumentObservations => {
          this.observationDocumentObservations = observationDocumentObservations;
        }, () => {
          this.errorHandlingService.showErrorWarning().subscribe(() => {
          });
        });
      }      
    }
  }

  ngOnDestroy() {
    this.loggedInUserSubscription.unsubscribe();
  }

  initObservationDocument() {
    this.isEditing = false;
    this.documentUploadRequest = new FormData();
    this.tempDocumentSummary = new EntityDocumentSummary(this.observationDocumentSummary);
  }

  getSelectedDocumentType(documentTypeId: string): IDocumentType {
    return this.observationDocumentTypes.find(t => t.id === documentTypeId);
  }

  saveObservationDocumentClicked() {
    this.submitted = true;
    if (!this.tempDocumentSummary?.documentTypeId || !this.tempDocumentSummary?.documentCreationDate?.dateTime || !this.tempDocumentSummary?.originalFilename ||
      (!this.tempDocumentSummary?.extraDescription && this.getSelectedDocumentType(this.tempDocumentSummary?.documentTypeId)?.name === "Other")) {
      return false;
    }
    this.submitted = false;
    this.appendDocumentUploadRequest();
    this.loading = true;
    this.observationDocumentService.createOrUpdateObservationDocument(this.documentUploadRequest).subscribe(observationDocumentSummary => {
      this.loading = false;
      this.observationDocumentSummary = new ObservationDocumentSummary(observationDocumentSummary);
      this.isEditing = false;
      this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  downloadObservationDocument() {
    this.documentService.downloadOrOpenDocument(this.observationDocumentSummary, true);
  }

  openObservationDocument() {
    this.documentService.downloadOrOpenDocument(this.observationDocumentSummary);
  }

  //createOrEditObservation(observation?: IObservation, isEditing?: boolean, heading?: string, observationType?: ObservationType) {
  //  this.observationModalService.createOrEditObservation(observation, heading + this.observationDocumentSummary.originalFilename, isEditing, observationType).subscribe(observationModalRef => {
  //    observationModalRef.content.saveObservationClicked.subscribe(observationResult => {
  //      if (observationResult !== null) {
  //        if (observationResult.observationType === null) {
  //          observationResult.observationType = ObservationType.CompanyDocument;
  //        }
  //        let entityObservationId = '00000000-0000-0000-0000-000000000000';
  //        this.observationDocumentObservations?.forEach(ttObservationSummary => {
  //          if (ttObservationSummary.observationId === observationResult.id) {
  //            entityObservationId = ttObservationSummary.documentObservationId;
  //          }
  //        });
  //        this.observationsService.createOrUpdateDocumentObservation(observationResult as IObservation, this.documentId, this.companyId, entityObservationId).subscribe(observationDocObservation => {
  //          this.observationDocumentObservations = this.observationsService.updateObservationSummaries(this.observationDocumentObservations, observationDocObservation);
  //          this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
  //        }, () => {
  //          this.errorHandlingService.showErrorWarning().subscribe(() => {
  //          });
  //        });
  //        observationModalRef.dynamicDialogRef.close();
  //      }
  //    });
  //  });
  //}

  private populateBreadcrumbs() {
    const operativeBreadCrumbs = new Array<IBreadcrumb>();

    if (this.observationSummary.operativeId == null) {
      //Company observation document
      operativeBreadCrumbs.push({ label: this.loggedInUser.companyName + ' - Enterprise Documents', iconName: 'books', routeLink: `company-documents` } as IBreadcrumb);
      operativeBreadCrumbs.push({ label: this.observationDocumentSummary.originalFilename, iconName: 'book' } as IBreadcrumb);
    }
    else {
      //operative observation document
      operativeBreadCrumbs.push({ label: 'Operatives', iconName: 'user', routeLink: `operatives` } as IBreadcrumb);
      operativeBreadCrumbs.push({ label: 'Operative Documents', iconName: 'books', routeLink: `operative-documents` } as IBreadcrumb);
      operativeBreadCrumbs.push({ label: this.observationDocumentSummary.originalFilename, iconName: 'book' } as IBreadcrumb);
    }
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }

  private appendDocumentUploadRequest() {
    this.documentUploadRequest.append('ObservationId', this.observationDocumentSummary.observationId);
    this.documentUploadRequest.append('CompanyId', this.companyId);
    this.documentUploadRequest.append('DocumentId', this.tempDocumentSummary.documentId);
    this.documentUploadRequest.append('DocumentTypeId', this.tempDocumentSummary.documentTypeId);
    this.documentUploadRequest.append('ExtraDescription', this.tempDocumentSummary.extraDescription);

    this.documentUploadRequest.append('OriginalFilename', this.tempDocumentSummary.originalFilename);

    if (this.tempDocumentSummary.reviewDate.dateTime) {
      this.documentUploadRequest.append('DocumentReviewDate', this.tempDocumentSummary.reviewDate.dateTime);
    }
    if (this.tempDocumentSummary.expiryDate.dateTime) {
      this.documentUploadRequest.append('DocumentExpiryDate', this.tempDocumentSummary.expiryDate.dateTime);
    }
    this.documentUploadRequest.append('DocumentCreationDate', this.tempDocumentSummary.documentCreationDate.dateTime);
  }

  editClicked() {
    if (this.docDetailsContainerComponent.isCollapsed) {
      //this.docDetailsContainerComponent.expandClicked();
      this.docDetailsContainerComponent.panelToggle();
    }
    this.isEditing = true;
  }

  cancelClicked() {
    this.tempDocumentSummary = new EntityDocumentSummary(this.observationDocumentSummary);
    this.isEditing = false;
  }

  fileUploaded(file: File) {
    if (file) {
      this.documentUploadRequest.append('FormFile', file, file.name);
    } else {
      this.formIsValid = false;
    }
  }

  formStatusChange(formIsValid: any) {
    this.formIsValid = formIsValid;
  }

  removeFile(remove: boolean) {
    if (remove) {
      this.documentUploadRequest.delete('FormFile');
      this.formIsValid = false;
    }
  }
}
